import {AxiosResponse } from 'axios';

import apiClient from '../client';
import { AddOrderEmployeeDto } from 'interfaces/orders/orderEmployee';
import { OrderDto } from 'interfaces/orders/order';
import { ApiResponseDto } from 'interfaces/apiResponse';

interface OrderEmployeeService {
  add(orderId: string, postData: AddOrderEmployeeDto): Promise<OrderDto>
  remove(orderId: string, employeeId: string): Promise<OrderDto>
}

const endpoints = {
  add: (orderId: string) => `/orders/${orderId}/employees`,
  remove: (orderId: string, employeeId: string) => `/orders/${orderId}/employees/${employeeId}`,
}

export const orderEmployeeService: OrderEmployeeService = {
  add: async (orderId: string, postData: AddOrderEmployeeDto): Promise<OrderDto> => {
    const response: AxiosResponse<ApiResponseDto<OrderDto>> = await apiClient.post(endpoints.add(orderId), postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  remove: async (id: string, employeeId: string): Promise<OrderDto> => {
    const response: AxiosResponse<ApiResponseDto<OrderDto>> = await apiClient.delete(endpoints.remove(id, employeeId));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
}
